import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import Icon from "../Utils/Icon";
import classes from "./styles.module.css";

function TableRow({data, hasError, errors}) {
    const [isOpened, setIsOpened] = useState(false);

    const rowStyle = hasError
        ? {backgroundColor: "#fde1df", cursor: "pointer"}
        : {};

    function toggleOpened() {
        setIsOpened((prev) => !prev);
    }

    return (
        <React.Fragment>
            <tr style={rowStyle} onClick={toggleOpened} className={classes.Row}>
                {Object.keys(data).map(
                    (key) =>
                        key !== "id" && (
                            <td key={key} className={classes.Cell}>
                                {data[key]}
                            </td>
                        )
                )}
                <td className={classes.DropdownCell}>
                    {hasError &&
                        (isOpened ? (
                            <Icon className={classes.Icon} icon="cheveron-up" size="18px"/>
                        ) : (
                            <Icon className={classes.Icon} icon="cheveron-down" size="18px"/>
                        ))}
                </td>
            </tr>

            {hasError && isOpened && (
                <tr className={classes.InfoRow}>
                    <td colSpan="5">
                        <ul>
                            {errors &&
                                errors.map((error, index) => (
                                    <li key={index}>
                                        <FormattedMessage id="RegistryUpload.error.field"
                                                          defaultMessage="Поле"/>: {error.field}
                                        <br/>
                                        <FormattedMessage id="RegistryUpload.error.value"
                                                          defaultMessage="Значение"/>: {error.value}
                                        <br/>
                                        <FormattedMessage id="RegistryUpload.error.message"
                                                          defaultMessage="Сообщение"/>: {error.message}
                                    </li>
                                ))}
                        </ul>
                    </td>
                </tr>
            )}
        </React.Fragment>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/RegistryTable/TableRow.js